module.exports = __webpack_public_path__ + "assets/sentiment_positive_grey.decb543e.svg";